export default {
  isImageAbsolute: {
    type: 'boolean',
    default: false,
  },
  hasImageOnRight: {
    type: 'boolean',
    default: false,
  },
  imageHeight: {
    type: 'string',
    default: 'auto',
  },
  imageWidth: {
    type: 'string',
    default: 'auto',
  },
  imageOffset: {
    type: 'string',
    default: '0',
  },
  gap: {
    type: 'number',
    default: 0,
  },
};
